import dayjs, { Dayjs } from 'dayjs';
import { RadioInput } from '~/ui';
import { useTranslation } from 'react-i18next';
import { CustomDatePicker } from '~/components/Shared/CustomDatePicker/CustomDatePicker';
import styles from './AccommodationReportExtra.module.scss';

interface AccommodationReportExtraProps {
  reportType: string;
  onReportTypeChange: (type: string) => void;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
}

export const AccommodationReportExtra = ({
  reportType,
  onReportTypeChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: AccommodationReportExtraProps) => {
  const { t } = useTranslation();

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().startOf('day');
  };

  return (
    <div>
      <div className={styles.radioWrapper}>
        <RadioInput
          label={t('brief_report')}
          name="type_report"
          value="accommodation_analytics_all_export"
          onChange={() =>
            onReportTypeChange('accommodation_analytics_all_export')
          }
          checkValue={reportType}
          disabled={false}
        />
        <RadioInput
          label={t('full_report')}
          name="type_report"
          value="accommodation_statistics_export"
          onChange={() =>
            onReportTypeChange('accommodation_statistics_export')
          }
          checkValue={reportType}
          disabled={false}
        />
      </div>
      <div className={styles.dateWrapper}>
        <span className={styles.labelText}>
          {t('date')}
          <span className={styles.labelStar}>*</span>
        </span>
        <CustomDatePicker
          value={[startDate, endDate]}
          showPresets={true}
          disabledDate={disabledDate}
          onChange={(name, value) => {
            if (name === 'start_date') {
              onStartDateChange(value);
            } else if (name === 'end_date') {
              onEndDateChange(value);
            }
          }}
        />
      </div>
    </div>
  );
};
